<template>
  <table class="tb-row">
    <colgroup>
      <col style="width:20%;" />
      <col style="width:auto;" />
    </colgroup>
    <tbody>
    <tr>
      <th>현재 이메일</th>
      <td class="last">{{ props.mberEmail }}</td>
    </tr>
    <tr>
      <th>새 이메일</th>
      <td class="last">
        <input  type="text" placeholder="이메일"
                class="__left"
                style="width:100px;padding-left: 5px;"
                title="이메일"
                maxlength="60"
                v-model="mberEmail1"/>
        @
        <input type="text"
               style="width:140px;"
               maxlength="50"
               :readonly="mberEmail3? true: false"
               v-model="mberEmail2"/>
        <cd-selbx :cds="$cmmn.txt.emails"
                  :cd="mberEmail3"
                  :cd-txt="'val'"
                  :nm-txt="'lab'"
                  @select="selBxEmail_change"/>
      </td>
    </tr>
    </tbody>
  </table>
  <div class="info-txt-bottom">
    <p class="info1">서비스 관련 정보를 수신할 <span class="pc01">새로운 이메일 주소를 입력</span>해 주세요.</p>
  </div>
  <div class="layer-btn">
    <btn :txt="'취소'"
         :color="'white'"
         @click="btnCancl_click"/>
    <btn :txt="'변경'"
         :color="'purple'"
         @click="btnChng_click"/>
  </div>
</template>

<script setup>
import {computed, defineEmits, defineProps, ref} from "vue";
import {getUtils, getStore} from "@/utils/import";
const {$cmmn, $valid, $alert, $axios} = getUtils();
const {$loading} = getStore();

const mberEmail1 = ref('');
const mberEmail2 = ref('');
const mberEmail3 = ref('');
const mberEmail = computed(() => mberEmail1.value.trim() + '@' + mberEmail2.value.trim());

const selBxEmail_change = (selCd) => {
  mberEmail3.value = selCd;
  mberEmail2.value = selCd;
};

const props = defineProps({
  mberSn: {
    type: Number,
    required: true
  },
  mberEmail: {
    type: String,
    required: true}
});

const validEmail = () => {
  let isValid = true;
  let msg = '';

  const isInputMberEmail1 = mberEmail1.value;
  const isInputMberEmail2 = mberEmail2.value;
  if (isValid && (!isInputMberEmail1 || !isInputMberEmail2)) {
    isValid = false;
    msg = '이메일을 입력해주세요.';
  }

  if (isValid && !$valid.email(mberEmail.value)) {
    isValid = false;
    msg = '올바른 이메일형식을 입력해주세요.';
  }

  return {isValid, msg};
}

const btnChng_click = async () => {
  try {
    $loading.on();

    const {isValid, msg} = validEmail();
    if (!isValid) {
      await $alert(msg);
      return false;
    }

    await modifyMberEmail();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const modifyMberEmail = async () => {
  const mberSn = props.mberSn;

  const modifyParams = {
    mberSn,
    mberEmail: mberEmail.value,
    udmbSn: mberSn,
  }

  const {data} = await $axios.post('/api/mber/mber-email', modifyParams);
  if (data == 0) {
    await $alert('오류가 발생하였습니다. 다시 시도해주세요.');
    return false;
  }

  await $alert('변경되었습니다.');
  emits('chng-compt');
  close();
}

const emits = defineEmits(['close', 'chng-compt']);
const close = () => {
  emits('close');
}

const btnCancl_click = () => {
  close();
}
</script>

<style scoped>

</style>
